export default __webpack_public_path__ + "static/media/button_upload_ko.36c88fec.svg";